<!-- TODO pass offsetDistance as prop -->
<div *ngFor="let asset of assets; index as i; odd as odd"
    class="asset"
    [style.--ellipseSize.px]="((assets.length + 1) * ellipseBaseSize) - ((i+1) * 100)">
    <ui-icon
        [type]="asset.icon.type"
        [icon]="asset.icon.value"
        shape="circle"
        iconSize="60%"
        [size]="iconBaseSize + (assets.length - i) * 16"
        [bg]="asset.state ?? (asset.invertedColor ? asset.baseColor + '-5' : asset.baseColor)"
        [color]="(!asset.state && asset.invertedColor) ? asset.baseColor : 'light'"
        [style.offsetDistance.%]="odd ? (82 + i * 18) : (84 - i * 4)"
        [ngClass]="asset.state">
    </ui-icon>

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="none" class="color-{{asset.state ?? asset.baseColor}}-10">
        <circle cx="50%" cy="50%"
            [attr.r]="(256 - strokeWidth) / 2"
            [attr.stroke-width]="strokeWidth"
            [attr.stroke]="asset.strokeHasGradient ? 'url(#strokeGradient-'+ id +')' : 'currentColor'" />

        <defs *ngIf="asset.strokeHasGradient">
            <linearGradient id="strokeGradient-{{id}}" x1="50%" y1="100%" x2="50%" y2="0">
                <stop offset="0" stop-color="currentColor" class="color-{{asset.state ?? asset.baseColor}}-40"></stop>
                <stop offset="1" stop-color="currentColor" class="color-{{asset.state ?? asset.baseColor}}"></stop>
            </linearGradient>
        </defs>
    </svg>
</div>
